import * as SwitchPrimitive from "@radix-ui/react-switch";
import type * as React from "react";

import { cn } from "../utils";

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        `
        peer inline-flex h-[1em] w-[2em] px-[0.1em] shrink-0 cursor-pointer items-center rounded-full transition-colors
        focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background
        disabled:cursor-not-allowed disabled:opacity-50
        data-[state=checked]:bg-primary data-[state=unchecked]:bg-input data-[state=unchecked]:shadow-inner
      `,
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={`
          pointer-events-none block size-[0.8em] rounded-full bg-popover shadow-lg ring-0
          transition-transform data-[state=checked]:translate-x-[1em] data-[state=unchecked]:translate-x-0
        `}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
